import LegendASCScale from '../legend/LegendASCScale';
import ContentsBase from './ContentsBase';
import { formatIssueTime, formatValidTime } from "../../../utils/FPEUtils";
import { WX_ID_ASCSCALE } from "../../../store/WeatherContentsState";

class ASCScale extends ContentsBase {
  static NAME = WX_ID_ASCSCALE;
  static ASC_SCALE_TURBULENCE = 'Turbulence';
  static ASC_SCALE_CONVECTION = 'Convection';
  static ASC_SCALE_ICING = 'Icing';
  prevValidtime;
  contentsVisibleState = {
    Turbulence: true,
    Convection: true,
    Icing: true
  }
  setRevision;

  constructor(setRevision) {
    super('ASCScale', 'ASC_SCALE', 'ASCScale');
    this.OPT_NAME = 'ASC_Scale';
    this.setRevision = setRevision;
  }

  parseTimelist() {
    const fullList = this.dataReference.query("timelist").value();
    this.validtimeList = this._parseTimelist(fullList);
    if(this.prevValidtime) {
      if(this.isDiffPrevDataBaseValid()) {
        this.setRevision();
      }
    }
    this.prevValidtime = JSON.parse(JSON.stringify(this.validtimeList));
  }

  getOpt(data, fpMode) {
    return new Promise(resolve => {
      const makeOpt = () => {
        this.shownTime = this.getValidtimeClosestToTheDateForBaseValid(data, fpMode);
        return {
          ASC_Scale: {
            Basetime: this.shownTime.basetime,
            Validtime: this.shownTime.validtime,
            Visible: this.isVisible(),
            ...this.contentsVisibleState
          }
        };
      }
      if (this.updated) {
        resolve(makeOpt());
      } else {
        const intervalId = setInterval(() => {
          if (!this.updated) return;
          clearInterval(intervalId);
          resolve(makeOpt());
        }, 500);
      }
    });
  }

  getLegend() {
    return {
      id: ASCScale.NAME,
      label: 'ASCScale',
      component: LegendASCScale,
      contents: this
    }
  }

  getTimeInformation() {
    return {
      id: ASCScale.NAME,
      label: 'ASCScale',
      issueTime: this.shownTime ? formatIssueTime(this.shownTime.issuetime) : "---",
      validTime: this.shownTime ? formatValidTime(this.shownTime.validtime[0]) : "---"
    }
  }

  getContentsVisibleState() {
    return this.contentsVisibleState;
  }

  setContentsVisible(name, visible) {
    this.contentsVisibleState[name] = visible;
  }
}

export default ASCScale;